import {getPACustomerId, PaDataType, paMainUrl, retrieveBoughtTogether, retrievePAResult} from "./retrievalHelper";
import {IItemSearchResponse, ItemFactory} from "../../../typescript-library";
import {getShopId} from "../../lib/getShopId";
import {
  boughtTogetherElement,
  parentCategoriesElement,
  recommendationsElement,
  similarProductsElement
} from "./LazyCrossSelling";

const itemId = document.body.querySelector<HTMLElement>("#AddToCartButtonRoot, .product-cart-placeholder")?.dataset
  .itemid;

/**
 * Collect all pending pa-item-retrieval promises in an array
 */
export function collectCrossSellingJobs() {
  const paCustomerId = getPACustomerId();

  const jobs: Promise<PaDataType | IItemSearchResponse>[] = [];

  // 1.) Produktserien
  if (parentCategoriesElement) {
    const categoryId = Number(parentCategoriesElement.dataset.parentCategoryId ?? "0");
    const limit = Number(parentCategoriesElement.dataset.limit ?? "0");
    const currencyCode: string = window.c_ActiveCurrency;

    jobs.push(ItemFactory.getItems(getShopId(), {currencyCode, categoryId, limit}).catch((error: Error) => {
      if (__DEVELOPMENT__) {
        /* eslint-disable no-console */
        console.log("DEVELOP: ERROR");
        console.log(error);
        /* eslint-enable no-console */
      }

      return {
        availableFilters: [],
        itemContent: [],
        totalSearchHits: 0,
      };
    }));
  }

  // 2.) Ähnliche Produkte
  if (similarProductsElement) {
    let similarProductUrl = paMainUrl + "ProductDetail?";
    if (paCustomerId) {
      similarProductUrl += `customerId=${paCustomerId}&`;
    }

    // https://docs.particularaudience.com/api-definitions/personalized-pdp - FE-101380
    similarProductUrl += `productRef=${itemId}&items[0]=${itemId}&filterOutOfStock=false `;

    jobs.push(retrievePAResult(similarProductUrl, "similarProducts"));
  }

  // 3.) Kunden kauften auch
  if (boughtTogetherElement && itemId) {
    jobs.push(retrieveBoughtTogether(itemId));
  }

  // 4.) Empfehlungen (PDP)
  if (recommendationsElement) {
    let recommUrl = paMainUrl;
    if (paCustomerId) {
      // Personal Recommendations
      recommUrl += `Personalized?customerId=${paCustomerId}`;
    } else {
      // Popular Recommendations
      recommUrl += "PopularItems";
    }

    jobs.push(retrievePAResult(recommUrl, "recommendations"));
  }

  return jobs;
}
